__turbopack_context__.v({
  "btn": "page-module__2cPhhq__btn",
  "error": "page-module__2cPhhq__error",
  "field": "page-module__2cPhhq__field",
  "form-box": "page-module__2cPhhq__form-box",
  "form-side": "page-module__2cPhhq__form-side",
  "illustration": "page-module__2cPhhq__illustration",
  "links": "page-module__2cPhhq__links",
  "page": "page-module__2cPhhq__page",
  "sitename": "page-module__2cPhhq__sitename",
  "success": "page-module__2cPhhq__success",
  "tagline": "page-module__2cPhhq__tagline",
});
